<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item >首页</el-breadcrumb-item>
          <el-breadcrumb-item>淘客</el-breadcrumb-item>
          <el-breadcrumb-item>商品查询</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true">
          <el-form-item>
            <el-input  placeholder="关键词" v-model="queryParam.q" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input  placeholder="物料Id" v-model="queryParam.materialId" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="排序" >
            <el-select v-model="queryParam.sort" size="small" placeholder="请选择排序">
              <el-option label="销量" value="total_sales_desc"></el-option>
              <el-option label="淘客收入比率" value="tk_rate_desc"></el-option>
              <el-option label="累计推广量" value="tk_total_sales_desc"></el-option>
              <el-option label="总支出佣金" value="tk_total_commi_desc"></el-option>
              <el-option label="预估到价格" value="final_promotion_price_desc"></el-option>
              <el-option label="匹配分" value="match_desc"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优惠券" >
            <el-select v-model="queryParam.hasCoupon" size="small" placeholder="请选择优惠券">
              <el-option label="请选择" value=""></el-option>
              <el-option label="有优惠券" value="true"></el-option>
              <el-option label="无优惠券" value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" v-on:click="Search" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="items" style="width: 100%">
          <el-table-column  prop="itemBasicInfo.title" :show-overflow-tooltip="true" label="标题" width="200px"></el-table-column>
          <el-table-column  prop="itemBasicInfo.pictUrl" label="图标" width="80" align="center">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.itemBasicInfo.pictUrl"
                placement="right"
                trigger="hover"
              >
                <div>
                  <img
                    :src="scope.row.itemBasicInfo.pictUrl"
                    width="400"
                    
                  >
                </div>  
                <img
                  slot="reference"
                  :src="scope.row.itemBasicInfo.pictUrl"
                  width="20"
                  height="20"
                >
              </el-popover> 
              <p v-else>
                --
              </p>
            </template>         
          </el-table-column> 
          <el-table-column  prop="itemBasicInfo.annualVol" label="年销量"> </el-table-column>
          <el-table-column  prop="pricePromotionInfo.zkFinalPrice"  label="原价"></el-table-column>           
          <el-table-column  prop="pricePromotionInfo.finalPromotionPrice" label="券后价"></el-table-column>
          <el-table-column  prop="publishInfo.incomeRate" label="最高佣金"></el-table-column>
          <el-table-column  prop="itemBasicInfo.brandName" label="品牌名称"></el-table-column>   
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section> 
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { parseTime } from '@/utils/date'
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        queryParam:{
          materialId: 17004,
          q: '美食',
          hasCoupon: true,
          sort: 'total_sales_desc',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/TaoBao/GoodsQuery',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.items = resp.data.rows
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
	      return  parseTime(cellValue, '{y}-{m}-{d}')
      },    
      handleSizeChange(val) {
        this.queryParam.pagesize =  val
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>